/*
*	Автор RnD SoftLab (Davydov Lev aka S@DLer), 2015 - 2016.
*	Дата последнего изменения: 15.04.2016 09:35
*	Система: SimpleONG system.
*	GlobalSystemVersion: 0.7.1.1
*/

//////////////////
// Init Shadowbox.
Shadowbox.init(
{
	handleOversize: "resize",
	overlayOpacity: 0.8,
	modal: false
});

///////////////////////////////////////////////////////////////////////
// Определяем задачи при полной загрузке страницы для текущего шаблона.
$(document).ready(function () 
{
	
});
